import {
  SettingsProvider,
  SettingsService,
  Configuration,
  UserMode,
  HttpService,
  ServiceConfiguration,
} from "@sportal/api";

const { SecureBusiness, SubscriberSafety } = Configuration;

const mandatoryServicesConfigurations: Partial<
  Record<UserMode, ServiceConfiguration[]>
> = {
  [UserMode.SBSingle]: [SecureBusiness.Single, SubscriberSafety.SBSingle],
  [UserMode.SBProfile]: [
    SecureBusiness.Single,
    SecureBusiness.Multiple,
    SubscriberSafety.SBSingle,
    SubscriberSafety.SBMultiple,
  ],
};

export type SBSettingsService = (useMode: UserMode) => SettingsService;

export const makeSettingsService =
  (http: HttpService, baseUrl: string): SBSettingsService =>
  (userMode: UserMode): SettingsService =>
    new SettingsService(
      new SettingsProvider(http, baseUrl),
      mandatoryServicesConfigurations[userMode]
    );
